import {
  InventoryListTargetingModel,
  GetInventoryListForm,
} from '@/models/InventoryListTargeting'

const assignModel = data => {
  return data.map(o => new InventoryListTargetingModel(o))
}

const actions = {
  async GET_LIST_FOR_ADVERTISER(
    { commit },
    { pageNo, pageSize, advertiserId },
  ) {
    const getProps = new GetInventoryListForm({
      pageNo,
      pageSize,
    })
    let ret = await InventoryListTargetingModel.findByAdvertiserId(
      getProps,
      advertiserId,
    )
    const modeledItems = assignModel(ret.items)
    commit('SET_LIST', modeledItems)
    return ret.item
  },
  async GET_LIST_FOR_OEM({ commit }, { pageNo, pageSize, ownerProfileId }) {
    const getProps = new GetInventoryListForm({
      pageNo,
      pageSize,
      ownerProfileId,
    })
    let ret = await InventoryListTargetingModel.findByOwnerProfileId(getProps)
    const modeledItems = assignModel(ret.items)
    commit('SET_LIST', modeledItems)
    return ret.item
  },
}

export default actions
